import { useCallback, useState } from 'react';
import { appendCorrelationId } from '../lib/append-correlation-id';
import { CrossAppSignInLinkError, generateCrossAppSignInUrl } from '../services/subscription.service';
import { usePurchaseCompleteStore } from '../store/purchase-complete.store';

const createCorrelationId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = (Math.random() * 16) | 0;
    const value = char === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
};

export const useOpenSignaturePurchase = () => {
  const [isOpening, setIsOpening] = useState(false);

  const openPurchase = useCallback(async () => {
    setIsOpening(true);
    const correlationId = createCorrelationId();
    usePurchaseCompleteStore.getState().beginWait(correlationId);

    try {
      const signInUrl = await generateCrossAppSignInUrl();
      const url = appendCorrelationId(signInUrl, correlationId);
      const child = window.open(url, '_blank');
      if (!child) {
        usePurchaseCompleteStore.getState().dismiss();
        throw new CrossAppSignInLinkError('POPUP_BLOCKED');
      }
    } catch (error) {
      usePurchaseCompleteStore.getState().dismiss();
      throw error;
    } finally {
      setIsOpening(false);
    }
  }, []);

  return { openPurchase, isOpening };
};
